import download from 'downloadjs';
import { DocumentReferenceViewModel } from '../model/DocumentReferenceViewModel';
import { customFetch } from './CustomFetch';

export const downloadFile = async (fileReference: DocumentReferenceViewModel) => {
  const response = await customFetch(`file?containerId=${fileReference.containerId}&fileName=${fileReference.name}`);
  const blob = await response.blob();
  download(blob, fileReference.name);
}
